import { render, staticRenderFns } from "./SousMenuUser.vue?vue&type=template&id=7cf7ed35&scoped=true&"
import script from "./SousMenuUser.vue?vue&type=script&lang=js&"
export * from "./SousMenuUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf7ed35",
  null
  
)

export default component.exports